import { IServico } from '../../../../types/listItems';
import { ArrowRight } from 'lucide-react';

export function Item({ cod_servico, titulo }: IServico) {
    return (
        <li className="list-none group">
            <a
                href={`https://api-portal.itajai.sc.gov.br/portaladm-pmitajai/servico/acesso/cod/${cod_servico}`}
                target="_blank"
                className="text-on-surface dark:text-on-surface-dark/90 font-medium text-sm lg:text-xs no-underline flex items-center gap-2 py-2 px-3 rounded-lg hover:bg-white/50 dark:hover:bg-white/5 transition-all duration-300 hover:text-primary dark:hover:text-secondary hover:translate-x-1"
                rel="noreferrer"
            >
                <ArrowRight size={14} className="text-secondary/60 group-hover:text-secondary group-hover:scale-110 transition-all duration-300" />
                <span className="flex-1 truncate">{titulo}</span>
            </a>
        </li>
    )
}